import React from 'react';
import { Container, Card, CardBody, Table, Button, Col, Row } from 'reactstrap';
import { Link, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar, faFileWord, faFilePdf, faDownload, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import footerBg from "./../../assets/footerbg.jpg";
import appoint from "./../../assets/COMPASSIONATEAPPOINTMENTS.docx";
import martyrs from "./../../assets/HaryanaMartyrDetails.pdf";


const CapfMartyrs = () => {
    
    const navigate = useNavigate();

    const districts = [
        { name: "Ambala", count: 0 },
        { name: "Bhiwani", count: 0 },
        { name: "Charkhi Dadri", count: 0 },
        { name: "Faridabad", count: 0 },
        { name: "Fatehabad", count: 0 },
        { name: "Gurugram", count: 0 },
        { name: "Hisar", count: 0 },
        { name: "Jhajjar", count: 0 },
        { name: "Jind", count: 0 },
        { name: "Kaithal", count: 0 },
        { name: "Karnal", count: 0 },
        { name: "Kurukshetra", count: 0 },
        { name: "Narnaul", count: 0 },
        { name: "Nuh", count: 0 },
        { name: "Palwal", count: 0 },
        { name: "Panchkula", count: 0 },
        { name: "Panipat", count: 0 },
        { name: "Rewari", count: 0 },
        { name: "Rohtak", count: 0 },
        { name: "Sirsa", count: 0 },
        { name: "Sonepat", count: 0 },
        { name: "Yamuna Nagar", count: 0 }
    ];

    return (
        <>
            <div style={{
                backgroundImage: `url(${footerBg})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                padding: '30px 0',
                color: 'white',
                margin: '2%',
                borderRadius: '10px'
            }}>
                <Container>
                    <h3 className="fw-bold mb-0 text-center">
                        <FontAwesomeIcon icon={faStar} className="me-2" />
                        Martyrs
                    </h3>
                </Container>
            </div>

            <Container className="py-5">
                <Card className="border-0 mb-5" style={{ borderRadius: '20px', overflow: 'hidden', boxShadow: '0 12px 40px rgba(30,60,114,0.15)' }}>
                    <div style={{
                        background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
                        padding: '25px',
                        color: 'white'
                    }}>
                        <h4 className="fw-bold mb-0">
                            <FontAwesomeIcon icon={faStar} className="me-2" />
                            District-wise Martyrs Count
                        </h4>
                    </div>
                    <CardBody className="p-4">
                        <div className="table-responsive">
                            <Table bordered hover className="mb-0">
                                <thead>
                                    <tr>
                                        <th style={{ background: '#1e3c72', color: 'white', width: '15%' }}>Sr. No.</th>
                                        <th style={{ background: '#1e3c72', color: 'white', width: '60%' }}>District</th>
                                        <th style={{ background: '#1e3c72', color: 'white', width: '25%' }}>Count</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {districts.map((district, index) => (
                                        <tr key={district.name}>
                                            <td style={{ color: '#495057' }}>{index + 1}</td>
                                            <td style={{ color: '#1e3c72', fontWeight: '600' }}>{district.name}</td>
                                            <td>
                                                <Link 
                                                    to={`/district-capf/${district.name}`}
                                                    style={{
                                                        background: 'linear-gradient(135deg, #16a085 0%, #27ae60 100%)',
                                                        color: 'white',
                                                        textDecoration: 'none',
                                                        fontSize: '14px', 
                                                        fontWeight: '600',
                                                        borderRadius: '20px',  
                                                        padding: '8px 20px', 
                                                        display: 'inline-block',
                                                        transition: 'all 0.3s'
                                                    }}
                                                    onMouseOver={(e) => {
                                                        e.currentTarget.style.background = 'linear-gradient(135deg, #16a085 0%, #27ae60 100%)';
                                                        e.currentTarget.style.transform = 'scale(1.05)';
                                                    }}
                                                    onMouseOut={(e) => {
                                                        e.currentTarget.style.background = 'linear-gradient(135deg, #16a085 0%, #27ae60 100%)';
                                                        e.currentTarget.style.transform = 'scale(1)';
                                                    }}
                                                >
                                                    {district.count}
                                                </Link>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </div>
                    </CardBody>
                </Card>

                <Row>
                    <Col md={6} className="mb-3">
                        <a 
                            href={appoint} 
                            target='_blank' 
                            rel="noopener noreferrer"
                            download 
                            style={{ textDecoration: 'none' }}
                        >
                            <div style={{
                                background: 'linear-gradient(135deg, #16a085 0%, #27ae60 100%)',
                                color: 'white',
                                padding: '20px',
                                borderRadius: '15px',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '15px',
                                boxShadow: '0 8px 25px rgba(22,160,133,0.3)'
                            }}>
                                <div style={{
                                    background: 'rgba(255,255,255,0.2)',
                                    padding: '15px',
                                    borderRadius: '10px'
                                }}>
                                    <FontAwesomeIcon icon={faFileWord} style={{ fontSize: '1.5rem' }} />
                                </div>
                                <div className="flex-grow-1">
                                    <h5 className="fw-bold mb-1">Compassionate Appointments</h5>
                                    <small style={{ opacity: 0.9 }}>Click to Download</small>
                                </div>
                                <FontAwesomeIcon icon={faDownload} style={{ fontSize: '1.2rem' }} />
                            </div>
                        </a>
                    </Col>
                    <Col md={6} className="mb-3">
                        <a 
                            href={martyrs} 
                            target='_blank' 
                            rel="noopener noreferrer"
                            download 
                            style={{ textDecoration: 'none' }}
                        >
                            <div style={{
                                background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
                                color: 'white',
                                padding: '20px',
                                borderRadius: '15px',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '15px',
                                boxShadow: '0 8px 25px rgba(30,60,114,0.3)',
                                transition: 'all 0.3s ease'
                            }}>
                                <div style={{
                                    background: 'rgba(255,255,255,0.2)',
                                    padding: '15px',
                                    borderRadius: '10px'
                                }}>
                                    <FontAwesomeIcon icon={faFilePdf} style={{ fontSize: '1.5rem' }} />
                                </div>
                                <div className="flex-grow-1">
                                    <h5 className="fw-bold mb-1">Martyrs of Haryana</h5>
                                    <small style={{ opacity: 0.9 }}>Click to Download</small>
                                </div>
                                <FontAwesomeIcon icon={faDownload} style={{ fontSize: '1.2rem' }} />
                            </div>
                        </a>
                    </Col>
                </Row>
            </Container>
        </>
    );
};

export default CapfMartyrs;
